export default {
  MAIL_TEMPLATES: "Templates mail",
  MAIL_SETTINGS: "Param\u00e8tres mail",
  MAIL_LOGS: "Historique des envois",

  // Categories
  ALL_CATEGORIES: "Toutes les cat\u00e9gories",
  TRANSACTIONAL: "Transactionnel",
  NOTIFICATION: "Notification",
  MARKETING: "Marketing",

  // Status
  ALL_STATUS: "Tous les statuts",
  CUSTOMIZED: "Personnalis\u00e9",
  USING_DEFAULT: "Par d\u00e9faut",
  NO_MAIL_TYPES: "Aucun type de mail configur\u00e9.",

  // Actions
  CUSTOMIZE: "Personnaliser",
  CUSTOMIZE_CONFIRM: "Voulez-vous personnaliser le template \u00ab {name} \u00bb ? Une copie du mod\u00e8le par d\u00e9faut sera cr\u00e9\u00e9e.",
  RESET_DEFAULT: "R\u00e9tablir par d\u00e9faut",
  RESET_CONFIRM: "Supprimer votre personnalisation et revenir au mod\u00e8le par d\u00e9faut ?",
  EDIT_TEMPLATE: "Modifier le template",
  SEND_TEST: "Envoyer un test",
  SEND: "Envoyer",
  TEST_EMAIL: "Adresse email de test",

  // Messages
  TEMPLATE_CUSTOMIZED: "Template personnalis\u00e9 avec succ\u00e8s",
  TEMPLATE_SAVED: "Template enregistr\u00e9",
  TEMPLATE_RESET: "Template r\u00e9initialis\u00e9 au mod\u00e8le par d\u00e9faut",
  TEST_SENT: "Email de test envoy\u00e9",
  SETTINGS_SAVED: "Param\u00e8tres mail enregistr\u00e9s",

  // Editor
  SUBJECT: "Objet",
  SENDER_OVERRIDE: "Personnaliser l'exp\u00e9diteur",
  FROM_EMAIL: "Email exp\u00e9diteur",
  FROM_NAME: "Nom exp\u00e9diteur",
  REPLY_TO: "R\u00e9pondre \u00e0",
  REPLY_TO_NAME: "Nom r\u00e9ponse",
  REPLY_TO_EMAIL: "Email r\u00e9ponse",
  VARIABLES: "Variables disponibles",
  EMAIL_BUILDER: "Constructeur d'email",
  SUBJECT_REQUIRED: "L'objet est requis",
  CONTENT_REQUIRED: "Le contenu est requis",
  VALIDATION_ERROR: "Erreur de validation",

  // Settings
  SENDER_DEFAULTS: "Exp\u00e9diteur par d\u00e9faut",
  DEFAULT_LOCALE: "Langue par d\u00e9faut",
  BRANDING: "Identit\u00e9 visuelle",
  LOGO_URL: "URL du logo",
  LOGO_HEIGHT: "Hauteur du logo (px)",
  PRIMARY_COLOR: "Couleur primaire",
  SECONDARY_COLOR: "Couleur secondaire",
  FOOTER: "Pied de page",
  FOOTER_TEXT: "Texte du pied de page",
  UNSUBSCRIBE_URL: "Lien de d\u00e9sinscription",

  // Logs
  RECIPIENT: "Destinataire",
  TYPE: "Type",
  STATUS: "Statut",
  ENTRIES: "entr\u00e9es",
  LANGUAGE: "Langue",
  SELECT_ORGANIZATION: "S\u00e9lectionnez une organisation pour afficher ses templates mail.",
  TEMPLATES_LIST: "Liste des mod\u00e8les",
  CATEGORY: "Cat\u00e9gorie",
  LANGUAGES: "Langues",
  REPLY_TO_NAME: "Nom r\u00e9ponse",
  OVERRIDES: "Personnalisations",
  VIEW_IN_ORGANIZATION: "Voir dans l'organisation",
  EDIT_DEFAULT: "Modifier le mod\u00e8le par d\u00e9faut",
  EDIT_CUSTOMIZATION: "Modifier la personnalisation",
  DEFAULT_TEMPLATE_SAVED: "Mod\u00e8le par d\u00e9faut mis \u00e0 jour",

  // Log statuses
  STATUS_SENT: "Envoy\u00e9",
  STATUS_FAILED: "\u00c9chou\u00e9",
  STATUS_PENDING: "En attente",
  STATUS_OPENED: "Ouvert",
  STATUS_CLICKED: "Cliqu\u00e9",
  STATUS_BOUNCED: "Rejet\u00e9",
  LOCALE: "Langue",
  ADD_TEMPLATE_MAIL: "Ajouter un type de mail",
  MAIL_TYPE_CREATED: "Type de mail cr\u00e9\u00e9",
  CODE: "Code",
  DESCRIPTION: "Description",
  NAME_AND_DESCRIPTION: "Nom et description par langue",
  ADD_VARIABLE: "Ajouter une variable",
  NO_VARIABLES_YET: "Aucune variable ajout\u00e9e. Cliquez sur le bouton pour en ajouter.",
  GROUP: "Groupe",
  NO_MATCH: "Aucune variable correspondante",

  // Validation
  FIELD_REQUIRED: "Ce champ est obligatoire.",
  PLEASE_FIX_ERRORS: "Veuillez corriger les erreurs dans le formulaire.",
  NAME_REQUIRED_FOR: "Le nom est obligatoire pour la langue {locale}.",

  // Type settings
  TYPE_SETTINGS: "Paramètres du type",
  TYPE_SETTINGS_SAVED: "Paramètres du type enregistrés",

  DEFAULT: "Par défaut",
  PREVIEW: "Aperçu",

  // Layouts
  MAIL_LAYOUTS: "Layouts mail",
  EDIT_LAYOUT: "Modifier le layout",
  LAYOUT_SAVED: "Layout enregistré",
  LAYOUT_CREATED: "Layout créé",
  ADD_LAYOUT: "Ajouter un layout",
  SET_AS_DEFAULT: "Définir par défaut",
  LAYOUT_NAME: "Nom du layout",
  NO_LAYOUTS: "Aucun layout configuré.",
  SOURCE: "Source",
  PREVIEW_WITH_ORG: "Prévisualiser avec l'organisation",
  LAYOUT_SLOTS_HELP: "Slots disponibles : {{ content }}, {{ headerContent }}, {{ footerContent }}, {{ unsubscribeContent }}, {{ brandColor }}, {{ organizationName }}, {{ currentYear }}, {{ customCss }}, {{ logoHeight }}",

  // Copy locale
  COPY_FROM: "Copier depuis",
  COPY_FROM_LOCALE: "Copier le contenu d'une autre langue",
  COPY_FROM_LOCALE_TO: "Copier {from} → {to}",
  LOCALE_COPIED: "Contenu copié de {from} vers {to}",
};
